package com.bikompanion.domain

/**
 * The ground a network actually serves, as the reach of its docks.
 *
 * [bounds] alone is too generous to be useful: AMBici's stations are scattered across a dozen
 * municipalities ringing Barcelona, and the rectangle around them swallows a great deal of
 * countryside that has never seen a dock. [points] is the same area described dock by dock,
 * which is honest enough to dim the map against and still cheap enough to draw every frame.
 *
 * [bounds] is kept alongside because it answers "is this network worth polling for what the
 * camera is looking at" in a single comparison, before any of the points are touched. It
 * already includes the walking radius, so nothing inside a circle falls outside the box.
 */
data class NetworkCoverage(
    val bounds: BoundingBox,
    val points: List<CoveragePoint>,
)
